// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___3S0al"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App.css
// module id = 1047
// module chunks = 0